var __jsx = React.createElement;
import React from 'react';
import { Wrapper } from './styles';
var FloorPlanSection = function FloorPlanSection(_ref) {
  var floorPlanName = _ref.floorPlanName;
  return __jsx(Wrapper, null, __jsx("img", {
    src: "".concat(process.env.CDN_PHOTOS_URL, "/").concat(floorPlanName),
    alt: floorPlanName
  }));
};
export default FloorPlanSection;